import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import DateFormatter from "../../DateFormatter";
import { dateFine } from "../../../util/Utilities";

const EppOrdersColumns = [
    {
        Label: TableCheck,
        Component: TableCheck
    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'Motivo',
        Component: ({ value }) => (
            <span className={`badge ${value?.reason === 'traslado' ? 'bg-info text-white' : 'bg-success text-white'}`}>
                {value?.reason_text || (value?.reason === 'traslado' ? 'Traslado' : 'Nuevo ingreso')}
            </span>
        )
    },
    {
        Label: () => 'Elaborado por',
        Component: ({ value }) => value?.createdBy?.name || '--'
    },
    {
        Label: () => 'Trabajador',
        Component: ({ value }) => value?.user_name || '--'
    },
    {
        Label: () => 'RUT',
        Component: ({ value }) => value?.user_document_number || '--'
    },
    {
        Label: () => 'Cargo',
        Component: ({ value }) => value?.position?.name || '--'
    },
    {
        Label: () => 'Fecha de ingreso',
        Component: ({ value }) => value?.entry_date || '--'
    },
    {
        Label: () => 'Teléfono',
        Component: ({ value }) => value?.user_phone_number || '--'
    },
    {
        Label: () => 'Servicio desde',
        Component: ({ value }) => (value?.reason === 'traslado' ? value?.fromService?.name : null) || '--'
    },
    {
        Label: () => 'Servicio hasta',
        Component: ({ value }) => value?.service?.name || '--'
    },
    {
        Label: () => 'Estatus',
        Component: ({ value }) => <button className={`btn text-capitalize btn-${value?.status?.variant_color}`} type="button">
            {value?.status?.name}
        </button>
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    },
    {
        Label: () => 'Acciones',
        Component: ActionDropdown
    }
];

export default EppOrdersColumns;
